import landingPageImage_1 from "./images/landing-page-1.jpg";
import landingPageImage_2 from "./images/landing-page-2.jpg";
import landingPageImage_3 from "./images/landing-page-3.jpg";

export type ISlideImage = {
    src: string;
    toasts: Array<{
        top?: number;
        bottom?: number;
        left?: number;
        right?: number;
        title: string;
        body: string;
    }>;
};

export const slidesImages = [
    {
        src: landingPageImage_1,
        toasts: [
            {
                top: 20,
                right: 20,
                title: "Archie",
                prefix: "A",
                body: "I'm also studying Engineering! What are you most excited for? 📚",
            },
            {
                bottom: 20,
                left: 20,
                title: "Hannah",
                prefix: "H",
                body: "The campus facilities look awesome! 🔬 How about you?",
            },
        ],
    },
    {
        src: landingPageImage_2,
        toasts: [
            {
                bottom: 20,
                left: 20,
                title: "Fred",
                prefix: "F",
                body: "Can you let me know more about the Tennis society? 🎾",
            },
            {
                bottom: 120,
                left: 60,
                title: "Ambassador",
                prefix: "A",
                body: "Hey all! You can ask me anything about the societies we have here! 👋",
            },
        ],
    },
    {
        src: landingPageImage_3,
        toasts: [
            {
                top: 40,
                left: 20,
                title: "Chloe",
                prefix: "C",
                body: "I’d love to know what the nightlife is like off-campus! Any suggestions? 🎤",
            },
            {
                bottom: 20,
                left: 20,
                title: "Ben",
                prefix: "B",
                body: "What cafes would you recommend on campus? ☕️",
            },
        ],
    },
];
